import IsNullOrUndefined from "./ObjectUtils";

export const currencyFormatter = new Intl.NumberFormat('de-DE', { // es-ES
    style: 'currency',
    currency: 'EUR',
});

export const getPriceText = (price, showPrices) => {
    if (showPrices) {
        return (IsNullOrUndefined(price) || price === '0') ? currencyFormatter.format(0) : currencyFormatter.format(parseFloat(price));
    }

    return (price === null || price === '0') ? 'sin coste' : 'con coste';
};
